import { PhotoIcon } from '@heroicons/react/24/outline'
import type { GeneratedAdResponse } from '../../client'

const ACTION =
  'flex-1 rounded-lg bg-stone-100 py-1.5 text-xs font-medium text-slate-700 shadow-sm ring-1 ring-slate-300 transition ring-inset hover:bg-stone-200'

type Props = {
  ad: GeneratedAdResponse
  onEditImage: () => void
  onCreateAd: () => void
}

export default function DraftAdCard({ ad, onEditImage, onCreateAd }: Props) {
  return (
    <div className="flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-stone-100 shadow-sm transition hover:shadow-md">
      <div className="relative aspect-square overflow-hidden bg-stone-200">
        {ad.image_url ? (
          <img src={ad.image_url} alt="Generated ad" className="size-full object-cover" />
        ) : (
          <span className="flex size-full items-center justify-center">
            <PhotoIcon className="size-8 text-gray-300" />
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-3">
        <p className="mb-1 truncate text-xs font-semibold text-gray-900">{ad.headline || 'Untitled Ad'}</p>
        <p className="line-clamp-2 flex-1 text-[10px] text-gray-400">{ad.primary_text}</p>
        <div className="mt-2 flex gap-1.5">
          <button type="button" onClick={onEditImage} className={ACTION}>
            Edit Image
          </button>
          <button type="button" onClick={onCreateAd} className={ACTION}>
            Create Ad
          </button>
        </div>
      </div>
    </div>
  )
}
